import React from 'react';

import '../../global.css'

/** A dialog for confirming deletion or some other negaitve operation.
 * Put inside a "Modal", control modal display with local state.
 * */
export const ConfirmDelete = ( props ) => {

    const { title, message, confirmText, onConfirm, closeModalCallback } = props;

    return (
        <div>
            <h4 className="text-danger"> {title} </h4>
                <div className="top-padding big-bottom-margin">
                    {message}
                </div>
                {/*<div className="container pull-right top-padding">*/}
                <div className="pull-right">
                    <button className='btn btn-default right-margin' onClick={closeModalCallback}>
                        No
                    </button>

                    <button className='btn btn-danger' onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
        </div>
    )
};

/** A dialog with a title, message, one button with a callback */
export const MessageDialog = (props) => {

    const { title, message, buttonText, callback, closeModalCallback } = props;
   const noTopPadding = {
      paddingTop: '0px'
   };


   return (
        <div>
           {!!closeModalCallback &&
              <button
                 style={noTopPadding}
                 className="btn btn-link pull-right"
                 onClick={closeModalCallback}>
                 X
              </button>
           }
            <h4> {title} </h4>
            <div className="top-padding big-bottom-margin">
                {message}
            </div>
            <div className="pull-right">

                <button className='btn btn-info' onClick={callback}>
                    {buttonText}
                </button>
            </div>
        </div>
    )
};




// WEBPACK FOOTER //
// ./src/components/huntcomponents/dialogs.js